import api_config from '../config/api'

export default {
	getCertificates() {
		return api_config.get('api/certificate')
	},
}
